import type { ReadonlySignal } from '@preact/signals';
import { useEffect, useRef } from 'preact/hooks';
import useTranslations from '@/widgets/hooks/useTranslations';
import ModalOnDemand from '@/widgets/components/controls/ModalOnDemand/ModalOnDemand';
import type { Translations } from '../../config';
import { type Product } from '@/domain/Product';
import styles from './BundlesDrawer.module.scss';
import BundledListItem from './parts/BundleListItem.tsx';
import useMarketConfig from '@/widgets/hooks/useMarketConfig.tsx';
import { trackViewItemList } from '../../Tracking.ts';

const ITEM_LIST_NAME = 'save with bundle';

type BundleDrawerProps = {
  bundles: Product[];
  isOpen: ReadonlySignal<boolean>;
  onClose: () => void;
};

export default function BundlesDrawer({
  bundles,
  isOpen,
  onClose
}: BundleDrawerProps) {
  const itemListEventSent = useRef(false);
  const { t } = useTranslations<Translations>();
  const {
    financialSettings: { defaultCurrency }
  } = useMarketConfig();

  useEffect(() => {
    if (isOpen.value && !itemListEventSent.current) {
      trackViewItemList(bundles, defaultCurrency, ITEM_LIST_NAME);
      itemListEventSent.current = true;
    }
  }, [isOpen.value, trackViewItemList]);

  return (
    <ModalOnDemand
      heading={t(
        'productDetailsHero.otherWaysToShopSection.saveWithABundleLabel'
      )}
      closeBtnA11yLabel={t('components.modal.closeBtnA11yLabel')}
      position="side"
      isOpen={isOpen.value}
      onClose={onClose}
      fixedFooter
    >
      <ul class={styles.list}>
        {bundles.map((bundle) => (
          <BundledListItem product={bundle} key={bundle.id} />
        ))}
      </ul>
    </ModalOnDemand>
  );
}
